module.exports = __webpack_public_path__ + "static/img/Hx.9e81dc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Hx.jpg
// module id = wGDS
// module chunks = 1